import React, {useEffect, useState} from 'react';
import './App.css';
import AntSidebar from "./components/layout/AntSidebar";
import {Alert, Layout} from "antd";
import * as ReactGA from "react-ga";
import {AppContext} from "./components/libs/ContextLibs";
import {Auth} from "@aws-amplify/auth";
import {Routes, Route} from "react-router";
import AuthenticatedRoute from "./components/utils/AuthenticatedRoute";
import Home from "./components/pages/Home";
import Dashboard from "./components/pages/Dashboard";
import EmbedDashboard from "./components/pages/EmbedDashboard";
import Folder from "./components/pages/Folder";
import UserPreferences from "./components/pages/UserPreferences";
import UnauthenticatedRoute from "./components/utils/UnauthenticatedRoute";
import Login from "./components/auth/Login";
import ResetPasswordPublic from "./components/layout/ResetPasswordPublic";

const {Content} = Layout;

ReactGA.initialize('UA-168702636-1');
ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [user, setUser] = useState(null);
    const [userNameOverride, setUserNameOverride] = useState(null);
    const [isUserNameOverride, setIsUserNameOverride] = useState(false);

    useEffect(() => {
        const onLoad = () => {
            try {
                Auth.currentSession().then(async (res) => {
                    setUser(await Auth.currentUserInfo());
                            setIsAuthenticated(true);
                });

            } catch (e) {
                if (e !== 'No current user') {
                    console.log(e);
                }
            }
            setIsAuthenticating(false);
        };
        onLoad();
    }, []);

    async function handleLogout() {
        await Auth.signOut();
        setIsAuthenticated(false);
    }

    return (
        !isAuthenticating && (
            <>
                <Layout style={{minHeight: '100vh'}} className="layout" id="App">
                    <AppContext.Provider value={{
                        isAuthenticated,
                        setIsAuthenticated,
                        user,
                        setUser,
                        userNameOverride,
                        setUserNameOverride,
                        isUserNameOverride,
                        setIsUserNameOverride
                    }}>
                        <AntSidebar isAuthenticated={isAuthenticated} logout={handleLogout}/>
                        <Content>
                            {
                                (isUserNameOverride && userNameOverride) &&
                                <Alert message={"Viewing as " + userNameOverride} type="warning"/>
                            }
                            <Routes>
                                <Route path="/" element={
                                    <AuthenticatedRoute>
                                        <Home user={user}/>
                                    </AuthenticatedRoute>
                                } />
                                <Route path="/dashboard/:id" element={
                                    <AuthenticatedRoute>
                                        <Dashboard user={user}/>
                                    </AuthenticatedRoute>
                                } />
                                <Route path="/embed-dashboard/:id" element={
                                    <AuthenticatedRoute>
                                        <EmbedDashboard user={user}/>
                                    </AuthenticatedRoute>
                                } />
                                <Route path="/folder" element={
                                    <AuthenticatedRoute>
                                        <Folder user={user}/>
                                    </AuthenticatedRoute>
                                } />
                                <Route path="/user-preferences" element={
                                    <AuthenticatedRoute>
                                        <UserPreferences user={user}/>
                                    </AuthenticatedRoute>
                                } />

                                <Route path="/login" element={
                                    <UnauthenticatedRoute>
                                        <Login/>
                                    </UnauthenticatedRoute>
                                } />
                                <Route path="/reset-temp-password" element={
                                    <UnauthenticatedRoute>
                                        <ResetPasswordPublic/>
                                    </UnauthenticatedRoute>
                                } />
                            </Routes>
                        </Content>
                    </AppContext.Provider>
                </Layout>
            </>
        )
    );


}

export default App;